import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { GET_FAMILY_MEMBERS } from "../../store/loginService/types";
import * as service from "../../store/service";

interface IProps {
    closeDialog: any;
    dialogId: string;
    payAsYouGoPkgDetails: any;
}

const RenewFamilyMemberDialog: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const isCignaPartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2559
                ? true
                : false
            : false
    );
    const [addedFamilyMembers, setAddedFamilyMembers] = useState([] as any);
    const [removedFamilyMembers, setRemovedFamilyMembers] = useState([] as any);
    const [isLoading, setisLoading] = useState(false);

    useEffect(() => {
        getCancelledFamilyMember();
    }, []);

    const onSubmit = () => {
        props.closeDialog(true, removedFamilyMembers, addedFamilyMembers);
    };
    const onLogout = () => {
        props.closeDialog(false);
    };

    const getCancelledFamilyMember = () => {
        const requestBody = {
            packageId: props.payAsYouGoPkgDetails ? props.payAsYouGoPkgDetails.packageId : 0,
        };
        setisLoading(true);
        service
            .getCancelledUserFamily(requestBody)
            .then((data) => {
                if (!data["hasError"] && data["familyMembers"]) {
                    const householdMembers = data["familyMembers"].filter((x: any) => x.accountType === "Family Plan Adult")
                        ? data["familyMembers"].filter((x: any) => x.accountType === "Family Plan Adult")
                        : [];
                    setAddedFamilyMembers(householdMembers);
                    dispatch({ type: GET_FAMILY_MEMBERS, familyMembers: data["familyMembers"] });
                }
                setisLoading(false);
            })
            .catch(() => {
                setisLoading(false);
            });
    };

    const removeAccount = (member: any) => {
        const removedMember = addedFamilyMembers.splice(
            addedFamilyMembers.findIndex((element: any) => element.subcustomerId === member.subcustomerId),
            1
        );
        setRemovedFamilyMembers([...removedFamilyMembers, removedMember[0]]);
    };
    const addAccount = (member: any) => {
        const removedMember = removedFamilyMembers.splice(
            removedFamilyMembers.findIndex((element: any) => element.subcustomerId === member.subcustomerId),
            1
        );
        setAddedFamilyMembers([...addedFamilyMembers, removedMember[0]]);
    };
    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>Renew Your Household Members</h1>
            </div>

            <div className={`dialog-body ${isLoading ? "loading" : ""}`}>
                <React.Fragment>
                    <p>Would you also like to continue the services you have extended to the following household members at a new price?</p>
                    <div className="space-divider margin-top-l"></div>
                    <ul className="list-reset">
                        {addedFamilyMembers &&
                            addedFamilyMembers.length > 0 &&
                            addedFamilyMembers.map((member: any, index: number) => {
                                return (
                                    <div role="row" key={`household-${index}`} className="data-row row between-xs between-sm item-divider">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter padding-bottom-s">
                                            <div>
                                                <em className="las la-check-circle inline-icon status-good"></em>
                                                {` ${member.firstName} ${member.lastName}`}
                                            </div>
                                        </div>

                                        <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s text-align-right">
                                            {" "}
                                            <a onClick={() => removeAccount(member)} href="javascript:void(0);" className="default_link">
                                                {"Remove " + member.firstName}
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}

                        {removedFamilyMembers &&
                            removedFamilyMembers.length > 0 &&
                            removedFamilyMembers.map((member: any, index: number) => {
                                return (
                                    <div role="row" key={`household-${index}`} className="data-row row between-xs between-sm item-divider">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter padding-bottom-s">
                                            <div>
                                                <em className="las la-times inline-icon status-bad"></em>
                                                {` ${member.firstName} ${member.lastName}`}
                                            </div>
                                        </div>

                                        <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s text-align-right">
                                            {" "}
                                            <a onClick={() => addAccount(member)} href="javascript:void(0);" className="default_link">
                                                {"Add " + member.firstName}
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}
                    </ul>
                </React.Fragment>

                {!isCignaPartnerId && (
                    <p className="padding-top-s">
                        If you have questions about this change, please call <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>
                    </p>
                )}
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            id="btn-cancel-dark-web-add-financial-acc"
                            className="btn-default btn-link btn-no-padding btn-no-border"
                            onClick={() => onLogout()}
                        >
                            <span className="btn-text">Back</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" id="btn-cancellation-coninuation-submit" onClick={() => onSubmit()}>
                            <span className="btn-text">Continue</span>
                        </button>
                    </div>
                </div>
                {isCignaPartnerId && (
                    <div style={{ textAlign: "center", padding: "10px" }}>
                        <p className="padding-top-s">
                            If you have questions about this change, please call <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>
                        </p>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default RenewFamilyMemberDialog;
